import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, testId }) => (
  <div
    data-testid={testId}
    className="flex items-center gap-3 text-xs tracking-[0.25em] uppercase text-[#D4AF37] mb-5"
  >
    <span className="h-px w-8 bg-[#D4AF37]/60" />
    {children}
  </div>
);
